import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getManufacturerList } from "app/services/dashboard/manufacturerService";
import { BASE_URL } from "static/constants";

export const manufacturerListApi = createApi({
  reducerPath: "manufacturerListApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: ({ query }) => ({
    getManufacturerList: query({
      queryFn: () => {
        return { data: getManufacturerList() };
      },
    }),
  }),
});

export const { useGetManufacturerListQuery } = manufacturerListApi;
